import { connectionSelector } from "./eramReact/slices/connectionSlice";
import { syncMcaInputAction, syncUiInputAction, syncUiScrollAction } from "./actions";
import { dispatchUiSyncInputEvent, dispatchUiSyncMcaInputEvent, dispatchUiSyncScrollEvent } from "./customEvents";
import { useDispatch } from "react-redux";
import { isRestrictedUiAction } from "./restrictedUiAction";
export function createRootReducer(reducer) {
    return (state, action) => {
        const connection = state ? connectionSelector(state) : undefined;
        if (isRestrictedUiAction(action) &&
            action.meta?.forwarded &&
            connection &&
            connection.sectorId &&
            !connection.isActive &&
            state) {
            if (syncUiInputAction.match(action)) {
                dispatchUiSyncInputEvent(action.payload);
                return state;
            }
            if (syncUiScrollAction.match(action)) {
                dispatchUiSyncScrollEvent(action.payload);
                return state;
            }
            if (syncMcaInputAction.match(action)) {
                dispatchUiSyncMcaInputEvent(action.payload);
                return state;
            }
        }
        return reducer(state, action);
    };
}
export const useCommonDispatch = useDispatch;
//# sourceMappingURL=createRootReducer.js.map